import * as fileActions from 'actions/fileActions';
import { FILE_SORT_BY } from 'utils/constants';

const DEFAULT_PAGE_SIZE = 10;

const initialState = {
  success: false,
  pending: true,
  error: '',
  // All file data
  page: 0,
  pageSize: DEFAULT_PAGE_SIZE,
  query: '',
  sort: {
    by: FILE_SORT_BY.UPDATE_DATE,
    asc: false
  },
  /*
  Filters is an array of object with `id`, `field`, `op`, `value` keys
  Where
    - id: id of filter, auto-generated
    - field: field name,
    - op: 6 comparison operators (lt, lte, gt, gte, eq, ne)
    - value: value string
  */
  filters: [],
  totalItems: 0,
  data: [],
  item: null
};

const fileReducer = (state = initialState, action) => {
  switch (action.type) {
    case fileActions.FILE_ERROR:
      return {
        ...state,
        sucess: false,
        pending: false,
        error: action.message
      };
    case fileActions.FILE_LIST_REQUEST:
    case fileActions.FILE_UPLOAD_REQUEST:
    case fileActions.FILE_DELETE_REQUEST:
      return {
        ...state,
        pending: true
      };
    case fileActions.FILE_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        pending: false,
        data: action.data,
        totalItems: action.count
      };
    case fileActions.FILE_UPLOAD_SUCCESS:
    case fileActions.FILE_DELETE_SUCCESS:
      return {
        ...state,
        success: true,
        pending: false,
        item: action.data
      };
    case fileActions.FILE_PAGE_CHANGE:
      return {
        ...state,
        page: action.page
      };
    case fileActions.FILE_PAGE_SIZE_CHANGE:
      // Reset page to the first page (page = 0)
      return {
        ...state,
        pageSize: action.pageSize,
        page: 0,
      };
    case fileActions.FILE_CHANGE_SORT_TYPE:
      // Accept attribute as sort string, use constants from 'utils/constant'
      return {
        ...state,
        sort: {
          ...state.sort,
          by: action.attribute
        }
      };
    case fileActions.FILE_CHANGE_SORT_ORDER:
      // Either by ascending order or not
      return {
        ...state,
        sort: {
          ...state.sort,
          asc: action.asc
        }
      };
    case fileActions.FILE_SEARCH_QUERY:
      return {
        ...state,
        query: action.query
      };
    case fileActions.FILE_ADD_FILTER:
      return {
        ...state,
        filters: [
          ...state.filters,
          action.filter
        ]
      };
    case fileActions.FILE_REMOVE_FILTER: {
      const index = state.filters.findIndex(item => item.id === action.id);
      if (index < 0) {
        return state;
      }

      return {
        ...state,
        filters: [
          ...state.filters.slice(0, index),
          ...state.filters.slice(index + 1)
        ]
      };
    }
    default:
      return state;
  }
}

export default fileReducer;
